const API_URL = process.env.REACT_APP_API_URL;
const MASTER_API_URL = process.env.REACT_APP_MASTER_API_URL;
const HR_API_URL = process.env.REACT_APP_HR_API_URL;
const GOOGLE_MAP_API = process.env.GOOGLE_MAP_API;

const CUSTOM_INPUT_TYPES = [
  "text-input",
  "number-input",
  "multiline-text-input",
  "email-input",
  "select",
  "multi-select",
  "checkbox",
  "multi-checkbox",
  "date-picker",
  "datetime-picker",
];

export { API_URL, MASTER_API_URL, HR_API_URL, CUSTOM_INPUT_TYPES, GOOGLE_MAP_API };
